import styled from "styled-components"

const Nav = styled.nav`
  &,
  a,
  span,
  .active-link {
    color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`

export { Nav }
